import { AnalyticsService } from "../../../services/analytics-service";

export function PostnlDataLayerEvent(data: any, webchat: any) {
  if (!data?.intel) {
    console.error(`PostNL data layer event dispatch attempted but data.intel was "${data?.intel}"`);
    return;
  }

  const analyticsService = new AnalyticsService(() => webchat.client.socketOptions.sessionId);
  analyticsService.dispatchAnalytics(data.intel);
}
